import React from "react";
import "./SoftwareSkill.scss";
import {skillsSection} from "../../portfolio";

const iconColorBySkill = {
  Tableau: "#e97627",
  "Power BI": "#f2c811",
  Figma: "#a259ff",
  Excel: "#217346",
  "SQL Server": "#f4d000",
  reactjs: "#00c7f2",
  Flutter: "#1ba9f5",
  "R Programming": "#276dc3",
  GitHub: "#cf2f2f",
  Firebase: "#ff9100",
  Laravel: "#ff2d20",
  "html-5": "#e44d26",
  css3: "#1572b6",
  JavaScript: "#f7df1e",
  Python: "#3776ab",
  PHP: "#777bb4",
  WordPress: "#21759b",
  MySQL: "#00758f"
};

export default function SoftwareSkill() {
  return (
    <div>
      <div className="software-skills-main-div">
        <ul className="dev-icons">
          {skillsSection.softwareSkills.map((skills, i) => {
            return (
              <li
                key={i}
                className="software-skill-inline"
                name={skills.skillName}
              >
                <i
                  className={skills.fontAwesomeClassname}
                  style={{color: iconColorBySkill[skills.skillName] || "#0b2d67"}}
                ></i>
                <p>{skills.skillName}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
